<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="dialog-title">
        <h4 class="title">{{ 'dispenserAgreement.cancelDispenserAgreementModalTitle' | cxTranslate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismissModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="cx-dialog-body modal-body">
      {{ 'dispenserAgreement.cancelDispenserAgreementModalConfirmation' | cxTranslate }}
    </div>
    <div class="modal-footer">
      <button class="btn btn-sm btn-secondary" (click)="cancelDispenserAgreement()">
        {{ 'creditClaims.yes' | cxTranslate }}
      </button>
      <button class="btn btn-primary btn-sm" (click)="dismissModal()">{{ 'creditClaims.no' | cxTranslate }}</button>
    </div>
  </div>
</div>
@if (isLoading$ | async) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
